import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import loading from './modules/loading';
import advisers from './modules/advisers';
import banks from './modules/banks';
import location from './modules/location';
import headquarters from './modules/headquarters';
import agreements from './modules/agreements';
import feeTypes from './modules/fee-types';
import cnaes from './modules/cnaes';
import unsubscribeReasons from './modules/unsubscribe-reasons';
import users from './modules/users';
import contacts from "@/store/modules/contacts";
import distributionList from "@/store/modules/distributionList";
import {isDevelop} from '@/config';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		auth,
		loading,
		advisers,
		banks,
		location,
		headquarters,
		agreements,
		feeTypes,
		cnaes,
		unsubscribeReasons,
    users,
    contacts,
    distributionList
	},
	strict: isDevelop
});
